/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PatientActivationsPatientActivation model module.
 * @module model/PatientActivationsPatientActivation
 * @version v0.3
 */
export default class PatientActivationsPatientActivation {
  /**
   * Constructs a new <code>PatientActivationsPatientActivation</code>.
   * @alias module:model/PatientActivationsPatientActivation
   * @class
   * @param token {String} Auto-enrollment activation token
   * @param birthDate {Date} yyyy-mm-dd (ISO 8601)
   * @param password {String}
   */
  constructor(token, birthDate, password) {
    this.token = token;
    this.birthDate = birthDate;
    this.password = password;
  }

  /**
   * Constructs a <code>PatientActivationsPatientActivation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientActivationsPatientActivation} obj Optional instance to populate.
   * @return {module:model/PatientActivationsPatientActivation} The populated <code>PatientActivationsPatientActivation</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientActivationsPatientActivation();
      if (data.hasOwnProperty('token'))
        obj.token = ApiClient.convertToType(data['token'], 'String');
      if (data.hasOwnProperty('birth_date'))
        obj.birthDate = ApiClient.convertToType(data['birth_date'], 'Date');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('terms_accepted'))
        obj.termsAccepted = ApiClient.convertToType(data['terms_accepted'], 'Boolean');
    }
    return obj;
  }
}

/**
 * Auto-enrollment activation token
 * @member {String} token
 */
PatientActivationsPatientActivation.prototype.token = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} birthDate
 */
PatientActivationsPatientActivation.prototype.birthDate = undefined;

/**
 * @member {String} password
 */
PatientActivationsPatientActivation.prototype.password = undefined;

/**
 * Replacement email for account activation
 * @member {String} email
 */
PatientActivationsPatientActivation.prototype.email = undefined;

/**
 * Must be true to activate the account. Otherwise, returns 422 with terms_required: true.
 * @member {Boolean} termsAccepted
 */
PatientActivationsPatientActivation.prototype.termsAccepted = undefined;
